module.exports = __webpack_public_path__ + "static/media/loader_black.1a329022.gif";